import { reactive } from "vue";

const state = reactive({
    keyword: null,
});

const methods = {
    onSearch: function (data) {
        state.keyword = data;
    },
};


export default {
    state: state,
    methods: methods,
}
